<template>
    <div>

        <!-- Intervenants -->
        <h1 class="label">Matériel</h1>

        <div class="level">
            <b-button class="is-primary" @click="isAddModalActive = true">
                Ajouter un matériel
            </b-button>
            <b-button class="is-warning" @click="deleteAllMAT">
                Supprimer tous les matériels
            </b-button>
        </div>

        <b-table :data="mat">
            <template>
                <b-table-column field="mat" label="Fournisseur" width="300" sortable
                                v-slot="props">
                    {{ props.row.mat }}
                </b-table-column>

                <b-table-column field="cost" label="Coût" sortable v-slot="props">
                    {{ props.row.cost }} € {{ProjectType === "Subvention" ? "TTC" : "HT"}}
                </b-table-column>

                <b-table-column field="devis" label="N° de devis" v-slot="props">
                    {{ props.row.devis }}
                </b-table-column>

                <b-table-column field="comment" label="Commentaire" v-slot="props">
                    {{ props.row.comment || '_____________'}}
                </b-table-column>

                <b-table-column label="Editer" v-slot="props">
                    <b-button
                            type="is-warning"
                            icon-left="pen"
                            @click="openEditModal(props.row)"
                    ></b-button>
                </b-table-column>

                <b-table-column label="Supprimer" v-slot="props">
                    <b-button
                            type="is-danger"
                            icon-left="trash"
                            @click="deleteMAT(props.row)"
                    ></b-button>
                </b-table-column>

                <!-- Footer -->
                <template slot="footer">
                    <th style="width:40px">
                        <div class="th-wrap is-numeric"> Nb. : {{ mat.length }}</div>
                    </th>
                    <th>
                        <div class="th-wrap"> Total : {{ totalCost }} € {{ProjectType === "Subvention" ? "TTC" : "HT"}}</div>
                    </th>
                </template>

            </template>
        </b-table>

        <b-modal :active.sync="isEditModalActive" has-modal-card>
            <MATEditModal
                    :uuid="this.selectedLine.uuid"
                    :mat=this.selectedLine.mat
                    :cost=this.selectedLine.cost
                    :devis=this.selectedLine.devis
                    :comment=this.selectedLine.comment
                    @edit-mat="onEditMAT"
            ></MATEditModal>
        </b-modal>

        <b-modal :active.sync="isAddModalActive" has-modal-card>
            <MATAddModal
                    @add-mat="onAddMAT"
            ></MATAddModal>
        </b-modal>
    </div>

</template>

<script>
    import MATEditModal from "@/components/MATEditModal";
    import MATAddModal from "@/components/MATAddModal";
    import {v4 as uuidv4} from 'uuid';

    export default {
        name: "Materiel",
        components: {MATEditModal, MATAddModal},
        props: {
            ProjectType  : {
                required: true
            }
        },
        mounted() {
            if (localStorage.getItem("mat")) {
                this.mat = JSON.parse(localStorage.getItem("mat"));
            } else {
                this.mat = [];
            }
        },
        computed: {
            totalCost() {
                let sum = this.mat.reduce((acc, cur) => acc + Number(cur.cost), 0);
                this.$emit('updateProjectMaterielCost', sum);
                return sum
            },
        },
        methods: {
            openEditModal(line) {
                this.selectedLine = line;
                this.isEditModalActive = true;
            },
            onAddMAT(item) {
                // Add the item to the array
                this.mat.push({
                    uuid: uuidv4(),
                    mat: item.mat,
                    cost: item.cost,
                    devis: item.devis,
                    comment: item.comment
                });
                // save the updated array in localstorage
                this.saveLocalStorageMAT();
                this.isAddModalActive = false;
            },
            onEditMAT(item) {
                const mati = this.findMAT(item);
                // Apply the updated values
                mati.cost = item.cost;
                mati.devis = item.devis;
                mati.comment = item.comment;
                // save the updated array in localstorage
                this.saveLocalStorageMAT();
                // close the modal
                this.isEditModalActive = false;
            },
            deleteMAT(item) {
                this.$buefy.dialog.confirm({
                    title: `Supprimer la ligne`,
                    confirmText: "Supprimer la ligne",
                    type: "is-danger",
                    hasIcon: true,
                    message: `Etes-vous sûr de supprimer cette ligne ? Cette action ne pourra être annulée.`,
                    onConfirm: () => {
                        // find in the array and remove
                        const index = this.mat.indexOf(item);
                        this.mat.splice(index, 1);
                        // save the updated array in localstorage
                        this.saveLocalStorageMAT();
                    }
                });
            },
            deleteAllMAT() {
                this.$buefy.dialog.confirm({
                    title: `Supprimer tous les salariés`,
                    confirmText: "Oui, je confirme",
                    type: "is-danger",
                    hasIcon: true,
                    message: `Etes-vous sûr de vouloir supprimer l'ensemble des salariés ? Cette action ne pourra pas être annulée`,
                    onConfirm: () => {
                        this.mat = [];
                        // save the updated array in localstorage
                        this.saveLocalStorageMAT();
                    }
                });
            },
            findMAT(item) {
                return this.mat.find(mati => mati.uuid === item.uuid);
            },
            saveLocalStorageMAT() {
                localStorage.setItem("mat", JSON.stringify(this.mat));
                this.mat = JSON.parse(localStorage.getItem("mat"));
            }
        },
        data() {
            return {
                mat: [],
                isEditModalActive: false,
                selectedLine: {},
                isAddModalActive: false,
            }
        },
    }
</script>

<style scoped>

</style>
